import { useState } from "react";
import { Badge, Group, Popover } from "@mantine/core";

/**
 * Renders up to `limit` tag badges; when more exist, a clickable "+n" badge opens a popover
 * listing every tag. Replaces the dead "+n" count chips (and the detail view's silent cutoff)
 * so tags are reachable both in the cramped list view and on the profile. `limit <= 0` shows all.
 *
 * stopPropagation on the chip + dropdown keeps a click from also triggering an enclosing
 * row/card navigation handler.
 */
export default function ExpandableTags({ tags, limit = 3, size = "xs", gap = 4 }) {
  const [opened, setOpened] = useState(false);
  const list = tags ?? [];
  if (list.length === 0) return null;

  const shown = limit > 0 ? list.slice(0, limit) : list;
  const overflow = list.length - shown.length;

  return (
    <Group gap={gap} wrap="wrap">
      {shown.map((tag) => (
        <Badge key={tag} size={size} variant="light">{tag}</Badge>
      ))}
      {overflow > 0 && (
        <Popover opened={opened} onChange={setOpened} position="bottom-start" withArrow shadow="md" width={280}>
          <Popover.Target>
            <Badge
              size={size}
              variant="light"
              color="gray"
              style={{ cursor: "pointer" }}
              onClick={(e) => { e.stopPropagation(); setOpened((o) => !o); }}
            >
              +{overflow}
            </Badge>
          </Popover.Target>
          <Popover.Dropdown onClick={(e) => e.stopPropagation()}>
            <Group gap={gap} wrap="wrap">
              {list.map((tag) => (
                <Badge key={tag} size={size} variant="light">{tag}</Badge>
              ))}
            </Group>
          </Popover.Dropdown>
        </Popover>
      )}
    </Group>
  );
}
